var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCardsBlue = function SvgCreditCardsBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "credit-cards--blue_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".credit-cards--blue_svg__st0{fill:#0185ff}.credit-cards--blue_svg__st1{fill-rule:evenodd;clip-rule:evenodd}.credit-cards--blue_svg__st1,.credit-cards--blue_svg__st3{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2 26.1v16.7c0 1.4 1 2.4 2.4 2.4h32.8c1.4 0 2.4-1 2.4-2.4V26.1H14.2z",
    className: "credit-cards--blue_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 25.3h39.2v17.5c0 1.8-1.4 3.2-3.2 3.2H16.6c-1.8 0-3.2-1.4-3.2-3.2V25.3zm1.6 1.6v15.9c0 .9.7 1.6 1.6 1.6h32.8c.9 0 1.6-.7 1.6-1.6V26.9H15z",
    className: "credit-cards--blue_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8 22c0-1.4-1-2.4-2.4-2.4H16.6c-1.4 0-2.4 1-2.4 2.4v4.1h37.6V22z",
    className: "credit-cards--blue_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4 22c0-1.8 1.4-3.2 3.2-3.2h32.8c1.8 0 3.2 1.4 3.2 3.2v4.1c0 .4-.4.8-.8.8H14.2c-.4 0-.8-.4-.8-.8V22zm3.2-1.6c-.9 0-1.6.7-1.6 1.6v3.3h36V22c0-.9-.7-1.6-1.6-1.6H16.6z",
    className: "credit-cards--blue_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4 60.4H30.6c-1.4 0-2.4-1-2.4-2.4V37.2c0-1.4 1-2.4 2.4-2.4h32.8c1.4 0 2.4 1 2.4 2.4V58c0 1.3-1.2 2.4-2.4 2.4z",
    className: "credit-cards--blue_svg__st0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 35.6c-.9 0-1.6.7-1.6 1.6V58c0 .9.7 1.6 1.6 1.6h32.8c.8 0 1.6-.8 1.6-1.6V37.2c0-.9-.7-1.6-1.6-1.6H30.6zm-3.2 1.6c0-1.8 1.4-3.2 3.2-3.2h32.8c1.8 0 3.2 1.4 3.2 3.2V58c0 1.7-1.5 3.2-3.2 3.2H30.6c-1.8 0-3.2-1.4-3.2-3.2V37.2z",
    className: "credit-cards--blue_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9 44.4h-26v-1.6h26v1.6z",
    className: "credit-cards--blue_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.6 55.9c-1 0-1.7-.8-1.7-1.7v-2.6c0-1 .8-1.7 1.7-1.7H59c1 0 1.7.8 1.7 1.7v2.6c0 1-.8 1.7-1.7 1.7h-4.4z",
    style: {
      fill: "#0b1b34"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50.7c.5 0 .9.4.9.9v2.6c0 .5-.4.9-.9.9h-4.5c-.5 0-.9-.4-.9-.9v-2.6c0-.5.4-.9.9-.9H59zm0-1.6h-4.5c-1.4 0-2.5 1.1-2.5 2.5v2.6c0 1.4 1.1 2.5 2.5 2.5H59c1.4 0 2.5-1.1 2.5-2.5v-2.6c0-1.4-1.1-2.5-2.5-2.5z",
    className: "credit-cards--blue_svg__st3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8 52.7H34v-1.6h5.8v1.6z",
    className: "credit-cards--blue_svg__st1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8 25.5H14.2v4.2h37.6v-4.2z",
    className: "credit-cards--blue_svg__st3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47 52.7h-5.8v-1.6H47v1.6z",
    className: "credit-cards--blue_svg__st1"
  })));
};
export default SvgCreditCardsBlue;